import { IPlugin } from 'shared/mechanics/plugin';
import { IAuthPlugin } from 'shared/mechanics/auth';

import { IChatBroPlugin, ChatBroPlugin as ChatBroPluginImpl } from './chatbro';
import { IGoogleAnalyticsPlugin, GoogleAnalyticsPlugin as GoogleAnalyticsPluginImpl } from './google/analytics';
import { IGoogleAdsPlugin, GoogleAdsPlugin as GoogleAdsPluginImpl } from './google/ads';
import { GoogleAuthPlugin as GoogleAuthPluginImpl } from './google/auth';
import { IYandexAnalyticsPlugin, YandexAnalyticsPlugin as YandexAnalyticsPluginImpl } from './yandex/analytics';
import { IYandexAdsPlugin, YandexAdsPlugin as YandexAdsPluginImpl } from './yandex/ads';
import { YandexAuthPlugin as YandexAuthPluginImpl } from './yandex/auth';
import { VKontakteAuthPlugin as VKontakteAuthPluginImpl } from './vkontakte/auth';
import { YouKassaPaymentPlugin as YouKassaPaymentPluginImpl } from './youkassa/payments';
import { ISentryPlugin, SentryPlugin as SentryPluginImpl } from './sentry';

export const ChatBroPlugin: IChatBroPlugin = new ChatBroPluginImpl();
export const GoogleAnalyticsPlugin: IGoogleAnalyticsPlugin = new GoogleAnalyticsPluginImpl();
export const GoogleAdsPlugin: IGoogleAdsPlugin = new GoogleAdsPluginImpl();
export const YandexAnalyticsPlugin: IYandexAnalyticsPlugin = new YandexAnalyticsPluginImpl();
export const YandexAdsPlugin: IYandexAdsPlugin = new YandexAdsPluginImpl();
export const SentryPlugin: ISentryPlugin = new SentryPluginImpl();

const GoogleAuthPlugin: IPlugin & IAuthPlugin = new GoogleAuthPluginImpl();
const YandexAuthPlugin: IPlugin & IAuthPlugin = new YandexAuthPluginImpl();
const VKontakteAuthPlugin: IPlugin & IAuthPlugin = new VKontakteAuthPluginImpl();
export const AuthPlugins = {
	all: [GoogleAuthPlugin, YandexAuthPlugin, VKontakteAuthPlugin],
	concrete: {
		google: GoogleAuthPlugin,
		yandex: YandexAuthPlugin,
		vkontakte: VKontakteAuthPlugin
	}
};

export const YouKassaPaymentPlugin: YouKassaPaymentPluginImpl = new YouKassaPaymentPluginImpl();